const employmentContractTypes = [
  { title: 'Boleta de Honorarios', value: 'tax_bill' },
  { title: 'Contrato de Trabajo', value: 'contract' },
  { title: 'Sin contrato', value: 'without_contract' },
];

export { employmentContractTypes };
